import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { c as computePosition, o as offset, f as flip, s as shift, a as size } from './floating-ui.dom.esm.js';
import { a as addToOverlay, r as removeFromOverlay } from './overlay.js';
import { d as defineCustomElement$2 } from './prism-menu-base2.js';

const prismMenuCss = ":host{width:fit-content;height:fit-content;display:block}";
const PrismMenuStyle0 = prismMenuCss;

const sharedCss = ".prism-headline-mega{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20);text-transform:uppercase;}.prism-headline-mega-inlined{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-90);text-transform:uppercase;}.prism-headline-2xl{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-2xl-inlined{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-xl{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-xl-inlined{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-large{font-size:var(--prism-typography-global-type-scale-step5);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30)}.prism-headline-medium{font-size:var(--prism-typography-global-type-scale-step4);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-small{font-size:var(--prism-typography-global-type-scale-step3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-headline-xs{font-size:var(--prism-typography-global-type-scale-step2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-subtitle-1{font-size:var(--prism-typography-global-type-scale-step1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-subtitle-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-1,body{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-large);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-button,button{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100)}.prism-caption,caption,figcaption{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-overline{font-size:var(--prism-typography-global-type-scale-step-2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-larger);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.prism-microlabel{font-size:var(--prism-typography-global-type-scale-step-3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-largest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.pwc-none{display:none}.pwc-visually-hidden{border:0;height:0;margin:0;padding:0;outline:0;overflow:hidden;position:absolute;white-space:nowrap;width:1px;appearance:none}.pwc-input-label{position:absolute;left:0;top:50%;transform:translateY(-50%);transition:0.1s ease-out;transform-origin:left top;pointer-events:none}.pwc-input{outline:none;background-color:transparent;color:var(--prism-color-theme-ink);padding:var(--prism-spacing-global-small) 0;width:100%}";
const PrismMenuStyle1 = sharedCss;

const PrismMenu$1 = /*@__PURE__*/ proxyCustomElement(class PrismMenu extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.valueChange = createEvent(this, "valueChange", 7);
        this.visibleChange = createEvent(this, "visibleChange", 7);
        this.triggerButtonClick = this.handleTriggerClick.bind(this);
        this.closeOnClickListener = this.closeMenu.bind(this);
        this.placement = 'bottom-start';
        this.visible = false;
        this.submenu = undefined;
        this.editableSelectMenu = undefined;
        this.value = undefined;
    }
    /**
     * Handles the 'itemSelected' event when a menu item is selected.
     * Updates the value of the component to the selected menu item's value
     * and emits the updated value through the 'valueChange' event.
     */
    handleValueChange(event) {
        if (this.visible &&
            !this.submenu &&
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event.target.tagName.toLowerCase() === 'prism-menu-item') {
            this.value = event.detail;
            this.valueChange.emit(this.value);
        }
    }
    /**
     * Watcher for the 'visible' property.
     * It removes the click listener when the menu closes.
     */
    watchVisible(visible) {
        var _a, _b, _c, _d;
        if (!visible) {
            document.body.removeEventListener('click', this.closeOnClickListener);
            (_a = this.triggerButton) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-controls');
            // focus the menu trigger after closing the menu
            (_b = this.triggerButton) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            // Use requestAnimationFrame to defer the addition of the click event listener
            // so that the menu opens on trigger button click
            const addClickEventListener = () => {
                document.body.addEventListener('click', this.closeOnClickListener);
            };
            requestAnimationFrame(addClickEventListener);
        }
        (_c = this.triggerButton) === null || _c === void 0 ? void 0 : _c.setAttribute('aria-expanded', `${visible}`);
        (_d = this.triggerButton) === null || _d === void 0 ? void 0 : _d.setAttribute('aria-controls', 'menu-base');
        this.visibleChange.emit(visible);
    }
    /**
     * Handles the keydown event for the specified element.
     */
    handleKeyDown(event) {
        if (this.visible) {
            if (event.key === 'Escape') {
                this.closeAllMenus(event);
                event.preventDefault();
                event.stopPropagation();
            }
            else if (event.key === 'Tab') {
                this.closeAllMenus(event);
            }
        }
    }
    /**
     * Opens the selected menu on the trigger button click.
     */
    handleTriggerClick() {
        if (!this.visible) {
            this.visible = true;
        }
    }
    /**
     * Closes the menu if it is currently visible.
     * It checks if the click target is not any of the menu items with submenus.
     * If the conditions are met, it hides the menu by setting the `visible` property to false.
     */
    closeMenu(event) {
        if (this.visible) {
            const menuItemsWithSubmenus = [...document.querySelectorAll('prism-menu-item[submenu]')];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (!menuItemsWithSubmenus.includes(event.target)) {
                event.preventDefault();
                this.closeAllMenus(event);
            }
        }
    }
    /**
     * Executed after rendering the component. It is responsible for positioning the menu element
     * based on the visibility and submenu conditions.
     * If the menu has a submenu, it calculates and sets the position of the menu based on the parent submenu item.
     * If the menu does not have a submenu, it calculates and sets the position of the menu
     * based on the `triggerButton` and the specified placement.
     */
    componentDidRender() {
        var _a;
        const menu = (_a = this.menuBase.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.pwc-menu-wrapper');
        if (this.submenu) {
            if (this.visible) {
                const submenuItemParent = document.querySelector(`prism-menu-item[submenu=${this.hostElement.id}]`);
                computePosition(submenuItemParent, menu, {
                    placement: 'right-start',
                    middleware: [
                        offset({ crossAxis: -8 }),
                        flip(),
                        shift({ padding: 5 }),
                        size({
                            apply({ availableHeight }) {
                                Object.assign(menu.style, {
                                    maxHeight: `${availableHeight - 30}px`
                                });
                            }
                        })
                    ]
                }).then(({ x, y, placement }) => {
                    // check if the submenu appears at the end and adjust offset
                    if (placement === 'right-end' || placement === 'left-end') {
                        y += 16;
                    }
                    Object.assign(menu.style, {
                        left: `${x}px`,
                        top: `${y}px`
                    });
                });
            }
        }
        else {
            if (this.visible && this.triggerButton) {
                computePosition(this.triggerButton, menu, {
                    placement: this.placement,
                    middleware: [
                        offset(5),
                        flip(),
                        shift({ padding: 5 }),
                        size({
                            apply({ availableHeight }) {
                                Object.assign(menu.style, {
                                    maxHeight: `${availableHeight - 30}px`
                                });
                            }
                        })
                    ]
                }).then(({ x, y }) => {
                    Object.assign(menu.style, {
                        left: `${x}px`,
                        top: `${y}px`
                    });
                });
            }
        }
    }
    /**
     * Updates the component when the visibility changes.
     *
     * When the menu becomes visible, this method ensures the menu-base and the menu items
     * are moved to a new div element at the top of the body.
     * This div element is created if it does not already exist, and the menu
     * is appended to this div to ensure it is displayed above all other elements on the page.
     */
    componentDidUpdate() {
        if (this.visible) {
            const menuItems = [...this.hostElement.querySelectorAll('prism-menu-item')];
            addToOverlay(this.menuBase);
            menuItems.forEach((menuItem) => {
                this.menuBase.appendChild(menuItem);
            });
            if (!this.editableSelectMenu) {
                // Focus the menu base to listen for keydown events
                this.menuBase.focus({ preventScroll: true });
            }
        }
        else {
            removeFromOverlay(this.menuBase);
        }
    }
    /**
     * Lifecycle method called when the component is disconnected from the DOM.
     * Removes the click event listener from the trigger button.
     */
    disconnectedCallback() {
        var _a;
        (_a = this.triggerButton) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.triggerButtonClick);
    }
    render() {
        return (h(Host, { key: 'f7ce78b159c6701338e56091ead8d96205f8f9c3' }, h("slot", { key: '675d47b6918e9aef62732da3b43efe18d0d8da87', name: "menu-trigger", onSlotchange: (e) => this.slotChange(e) }), h("prism-menu-base", { key: '88a9a1b81e86d0307d5c67dd237cb17c9321de4b', id: this.submenu ? `${this.hostElement.id}-menu-base` : 'menu-base', visible: this.visible, submenu: this.submenu, parentMenu: this.hostElement, ref: (el) => (this.menuBase = el) })));
    }
    /**
     * Gets the trigger button and adds a click event listener to it.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    slotChange(event) {
        var _a, _b, _c;
        this.triggerButton = event.target.assignedElements()[0];
        (_a = this.triggerButton) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.triggerButtonClick);
        (_b = this.triggerButton) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-haspopup', 'true');
        (_c = this.triggerButton) === null || _c === void 0 ? void 0 : _c.setAttribute('aria-expanded', `${this.visible}`);
    }
    /**
     * Removes the active property from all menu items and removes the overlay.
     */
    deactivateAllMenuItems() {
        const menuItems = [...document.querySelectorAll('prism-menu-item[active]')];
        menuItems.forEach((item) => item.removeAttribute('active'));
    }
    /**
     * Closes all open menus.
     */
    closeAllMenus(event) {
        this.visible = false;
        this.deactivateAllMenuItems();
        if (event.type === 'keydown') {
            const openMenus = [...document.querySelectorAll('prism-menu[visible]')];
            openMenus.forEach((menu) => {
                menu.visible = false;
            });
        }
    }
    get hostElement() { return this; }
    static get watchers() { return {
        "visible": ["watchVisible"]
    }; }
    static get style() { return PrismMenuStyle0 + PrismMenuStyle1; }
}, [1, "prism-menu", {
        "placement": [1],
        "visible": [1540],
        "submenu": [4],
        "editableSelectMenu": [4, "editable-select-menu"],
        "value": [1025]
    }, [[16, "itemSelected", "handleValueChange"], [0, "keydown", "handleKeyDown"]], {
        "visible": ["watchVisible"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["prism-menu", "prism-menu-base"];
    components.forEach(tagName => { switch (tagName) {
        case "prism-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PrismMenu$1);
            }
            break;
        case "prism-menu-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const PrismMenu = PrismMenu$1;
const defineCustomElement = defineCustomElement$1;

export { PrismMenu, defineCustomElement };

